var _defs, _text, _text2, _text3, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _rect4, _polygon4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect5, _rect6, _rect7, _g8, _rect8, _rect9, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3, .cls-7, .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-6 {\n        stroke: #818182;\n      }\n\n      .cls-1, .cls-6, .cls-9 {\n        stroke-width: .25px;\n      }\n\n      .cls-2 {\n        fill: #f3eeff;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-7, .cls-8, .cls-9 {\n        stroke: #231815;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-8 {\n        stroke-width: .5px;\n      }\n\n      .cls-10 {\n        fill: #231815;\n        font-family: 'NanumSquare_acR', NanumSquare_ac;\n        font-size: 8px;\n      }\n\n      .cls-4 {\n        fill: #fffee9;\n      }\n\n      .cls-5 {\n        stroke: #00194c;\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        stroke-width: .75px;\n      }\n\n      .cls-8 {\n        fill: #f0fff7;\n      }\n\n      .financeTeam-seat {\n        fill: #fff0eb;\n      }\n      .none { fill: white; }\n      .thick-stroke {\n        fill: none;\n        stroke: #231815;\n        stroke-miterlimit: 10;\n        stroke-width: 0.5px;\n      }\n\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(452.95 140.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD68C\uC758\uC2E4"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(716.3 341.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD0D5\uBE44\uC2E4"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(243.08 167.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCC3D\uACE0/\uC11C\uACE0"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 253.37,
    y: 265.61,
    width: 2.98,
    height: 133.53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 773.61,
    y: 121.2,
    width: 1.49,
    height: 182.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 243.71,
    y: 147.09,
    width: 2.98,
    height: 157.15,
    transform: "translate(19.54 470.87) rotate(-90)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "362.19 224.17 362.19 102.83 359.2 102.83 359.2 224.17 354.1 224.17 354.1 227.16 359.2 227.16 362.19 227.16 366.92 227.16 366.92 224.17 362.19 224.17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "817.74 104.94 817.74 325.43 812.15 325.43 812.15 328.41 817.74 328.41 817.74 371.3 820.72 371.3 820.72 104.94 817.74 104.94"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "570.21 224.17 570.21 102.83 567.23 102.83 567.23 224.17 396.99 224.17 396.99 227.16 567.23 227.16 570.21 227.16 572.15 227.16 572.15 224.17 570.21 224.17"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 686.22,
    y: 138.27,
    width: 2.98,
    height: 174.78,
    transform: "translate(462.05 913.38) rotate(-90)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "708.92 250.04 687.9 250.04 684.92 250.04 684.92 253.02 684.92 399.14 687.9 399.14 687.9 253.02 708.92 253.02 708.92 250.04"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 572.52,
    y: 197.96,
    width: 1.87,
    height: 29.53,
    transform: "translate(1146.91 425.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M599.94,226.66c.03-.55.03-.86.03-1.22,0-14.28-11.16-27.48-24.88-27.48-.26,0-.47,0-.7,0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 366.92,
    y: 197.86,
    width: 2.05,
    height: 29.53,
    transform: "translate(735.88 425.24) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M396.96,226.55c.04-.55.03-.86.03-1.22,0-14.28-12.23-27.48-27.26-27.48-.28,0-.52,0-.76,0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 351.77,
    y: 197.86,
    width: 2.05,
    height: 29.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M323.78,226.55c-.04-.55-.03-.86-.03-1.22,0-14.28,12.23-27.48,27.26-27.48.28,0,.52,0,.76,0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 177.33,
    y: 361.39,
    width: 2.44,
    height: 35.28,
    transform: "translate(557.58 200.48) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.91,344.36c.66-.05,1.03-.03,1.45-.03,17.07,0,32.84,14.61,32.84,32.57,0,.34,0,.62-.01.91"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.31,
    y: 292.05,
    width: 2.47,
    height: 34.34,
    transform: "translate(-129.67 488.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.35,344.29c.64.05,1,.03,1.42.03,16.61,0,31.96-14.78,31.96-32.95,0-.34,0-.63-.01-.92"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 809.79,
    y: 296.96,
    width: 2.1,
    height: 31.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M781.06,327.46c-.04-.59-.03-.91-.03-1.29,0-15.18,12.55-29.21,27.97-29.21.29,0,.53,0,.78.01"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "168.25 96.27 160.37 96.27 159.08 96.27 159.08 308.25 168.25 308.25 168.25 105.44 770.52 105.44 770.52 125.12 779.69 125.12 779.69 105.44 824.52 105.44 824.52 96.27 168.25 96.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "775.1 328.41 780.55 328.41 780.55 325.43 775.1 325.43 775.1 302.43 765.94 302.43 765.94 394.56 168.25 394.56 168.25 380.62 159.08 380.62 159.08 403.73 160.37 403.73 168.25 403.73 765.94 403.73 775.1 403.73 775.1 394.56 775.1 380.47 820.72 380.47 820.72 371.3 775.1 371.3 775.1 328.41"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 468.02,
    y: 277.04,
    width: 105.72,
    height: 10.14
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 341.02,
    y: 277.04,
    width: 70.72,
    height: 10.14
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 632.02,
    y: 277.04,
    width: 50.72,
    height: 10.14
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "team1-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 465.42,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(177.68 806.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 465.42,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(124.3 859.92) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 363.46,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(75.72 704.58) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 363.46,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(22.34 757.96) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.94,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(48.2 677.06) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 335.94,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(-5.18 730.44) rotate(-90)"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 243.41,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(-44.32 584.53) rotate(-90)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 243.41,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(-97.7 637.91) rotate(-90)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "team2-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 525.57,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(237.83 866.69) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 525.57,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(184.45 920.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 641.62,
    y: 300.67,
    width: 53.38,
    height: 27.52,
    transform: "translate(353.88 982.74) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 641.62,
    y: 354.05,
    width: 53.38,
    height: 27.52,
    transform: "translate(300.5 1036.12) rotate(-90)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "team3-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 557.32,
    y: 118.32,
    width: 53.38,
    height: 27.52,
    transform: "translate(451.93 716.09) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 696.92,
    y: 105.5,
    width: 53.38,
    height: 27.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8 none",
    x: 662.92,
    y: 196.66,
    width: 53.38,
    height: 27.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8 none",
    x: 609.54,
    y: 196.66,
    width: 53.38,
    height: 27.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 427.98,
    y: 151.24,
    width: 68.93,
    height: 35.37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLayout);
export default __webpack_public_path__ + "static/media/fullLayout.fab0036e2a20ce242ca83991e62ce7ed.svg";
export { ForwardRef as ReactComponent };